import { render, staticRenderFns } from "./ocrConfig.vue?vue&type=template&id=6f66cb2d&"
import script from "./ocrConfig.vue?vue&type=script&lang=js&"
export * from "./ocrConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f66cb2d')) {
      api.createRecord('6f66cb2d', component.options)
    } else {
      api.reload('6f66cb2d', component.options)
    }
    module.hot.accept("./ocrConfig.vue?vue&type=template&id=6f66cb2d&", function () {
      api.rerender('6f66cb2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/ocrConfig.vue"
export default component.exports